import React from 'react';
import { Box, Typography } from '@mui/material';
import { HideImage } from '@mui/icons-material';

interface NoImagePlaceholderProps {
  variant?: 'thumbnail' | 'detail';
}

/**
 * Lightweight placeholder for artwork with no image.
 * Replaces the former 13MB art.png fallback with a pure MUI component.
 */
export const NoImagePlaceholder: React.FC<NoImagePlaceholderProps> = ({
  variant = 'thumbnail',
}) => {
  const isDetail = variant === 'detail';

  return (
    <Box
      data-testid="no-image-placeholder"
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.100',
        borderRadius: 1,
        gap: isDetail ? 1.5 : 0.5,
      }}
    >
      <HideImage
        sx={{
          fontSize: isDetail ? 48 : 24,
          color: 'grey.400',
        }}
      />
      {isDetail && (
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary' }}
        >
          No Image Available
        </Typography>
      )}
    </Box>
  );
};
